/* eslint-disable no-bitwise */
export const GENDER = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  SECRET: 'SECRET',
};

export const GENDER_STRING_MAP = {
  [GENDER.MALE]: '先生',
  [GENDER.FEMALE]: '小姐',
  [GENDER.SECRET]: '保密',
};

export const COUPON_FILTER_TYPE = {
  VALID: 'VALID',
  INVALID: 'INVALID',
};

export const COUPON_APPLICABLE_CHANNEL = {
  OFFLINE: 1,
  ONLINE: 2,
};

export const COUPON_APPLICABLE_CHANNEL_STRING_MAP = {
  [COUPON_APPLICABLE_CHANNEL.OFFLINE]: '僅適用一般機台購餐，不包含預訂商品',
  [COUPON_APPLICABLE_CHANNEL.ONLINE]: '僅適用於預訂商品，不包含一般機台購餐',
  [COUPON_APPLICABLE_CHANNEL.OFFLINE | COUPON_APPLICABLE_CHANNEL.ONLINE]: '無限制',
};
